import { render, staticRenderFns } from "./UsersInfo.vue?vue&type=template&id=ca4e5188&scoped=true"
import script from "./UsersInfo.vue?vue&type=script&lang=js"
export * from "./UsersInfo.vue?vue&type=script&lang=js"
import style0 from "./UsersInfo.vue?vue&type=style&index=0&id=ca4e5188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4e5188",
  null
  
)

export default component.exports